<template>
  <tr>
    <th>{{item.name}}</th>
    <td class="text-right" colspan="2">
      <template v-if="item.type == 'string' || item.type == 'select_list'">
        <span class="multiline-text">{{item.value}}</span>
      </template>
      <template v-if="item.type == 'decimal'">
        {{item.value}}
      </template>
      <template v-if="item.type == 'date'">
        {{formatDate(item.value)}}
      </template>
      <b-container v-else-if="item.type == 'imageset'">
        <b-row>
          <b-col cols="4" v-for="(image, imageIndex) in item.images" :key="imageIndex">
            <a href="#" v-on:click.stop="showImageModal(image)">
              <b-img fluid :src="image.url"></b-img>
            </a>
          </b-col>
        </b-row>
        <b-modal ref="imageModal" size="lg" hide-header>
          <b-img fluid :src="modalImage.url" v-if="modalImage"></b-img>
          <footer slot="modal-footer">
            {{downloadMessage}}
            <a v-if="modalImage" :href="modalImage.url" target="_blank" class="btn btn-link">Download Image</a>
            <b-button variant="primary" v-on:click="hideImageModal">Close</b-button>
          </footer>
        </b-modal>
      </b-container>
      <b-container v-else-if="item.type == 'videoset'">
        <b-row>
          <b-col cols="4" v-for="(video, videoIndex) in item.videos" :key="videoIndex">
            <a href="#" v-on:click.stop="showVideoModal(video)">
              <b-img fluid :src="video.thumbnail_url"></b-img>
            </a>
          </b-col>
        </b-row>
        <b-modal ref="videoModal" size="lg" hide-header v-on:shown="playVideo" v-on:hide="stopVideo">
          <div class="text-center">
            <video ref="videoPlayer" controls v-if="modalVideo">
              <source :src="modalVideo.url" type="video/mp4">
            </video>
          </div>
          <footer slot="modal-footer">
            {{downloadMessage}}
            <a v-if="modalVideo" :href="modalVideo.url" target="_blank" class="btn btn-link">Download Video</a>
            <b-button variant="primary" v-on:click="hideVideoModal">Close</b-button>
          </footer>
        </b-modal>
      </b-container>
    </td>
  </tr>
</template>


<script>
import moment from 'moment'
import browser from 'browser-detect'

export default {
  name: 'DataItemRow',
  props: {
    item: { type: Object }
  },
  data () {
    return {
      modalImage: null,
      modalVideo: null
    }
  },
  computed: {
    modalImageIndex () {
      if (this.modalImage) {
        return this.item.images.indexOf(this.modalImage)
      } else {
        return null
      }
    },
    downloadMessage () {
      const result = browser()
      switch (result && result.name) {
        case 'edge':
          return "To download, right click link and select 'Save target as':"
        default:
          return "To download, right click link and select 'Save Link As':"
      }
    }
  },
  methods: {
    showImageModal (image) {
      this.modalImage = image
      this.$refs.imageModal.show()
    },
    hideImageModal () {
      this.modalImage = null
      this.$refs.imageModal.hide()
    },
    showVideoModal (video) {
      this.modalVideo = video
      this.$refs.videoModal.show()
    },
    hideVideoModal () {
      this.modalVideo = null
      this.$refs.videoModal.hide()
    },
    playVideo () {
      this.$refs.videoPlayer.play()
    },
    stopVideo () {
      this.$refs.videoPlayer.pause()
      this.$refs.videoPlayer.currentTime = 0
    },
    formatDate (date) {
      return moment(date, 'Y-M-D').format('D MMM YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataItemRow.vue